const $$splitComponentImporter = () => import('/Users/Javvad_1/Desktop/Petso_Dev/monorepo/petso-pro/src/routes/dashboard/patients.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { listPrescriptions } from '@/api/prescriptions';
import { type PetDetailSection } from '@/hooks/usePetDetail';
export const Route = createFileRoute('/dashboard/patients')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
type FormPayload = {
  name: string;
  speciesKey: SpeciesKey;
  breedKey: string;
  lastVisit: string;
  nextVaccine: string;
  petDid: string;
  microchip: string;
  ownerEmail: string;
  ownerName: string;
  ownerPhone: string;
};

// ─── Helper Components for ZKP-aware sections ──────────────────────────────